module.exports = __webpack_public_path__ + "img/zx6.cfbec302.png";